import React from 'react';
import {handicaddieSelector} from "../../../services/store/asyncThunk";
import ArrowLeftIcon from "../../../icons/ArrowLeftIcon";
import {IconSize} from "../../../services/IconConstants";
import {useNavigate} from "react-router-dom";
import {buildUrl, PLATFORM_CLUB_PREPAID_BAG_DASHBOARD} from "../../../services/PageUtils";
import Container from "../../../components/Container";
import {useAppDispatch} from "../../../services/store/store";
import {Club} from "../../../services/api/ClubService";
import {handleClubChange} from "../../../services/store/reducers/clubs/slice";

interface Props {

}

const PrepaidBagsMenu = ({}: Props) => {

    const { allClubs } = handicaddieSelector((state) => state.clubs)
    const nav = useNavigate();
    const dispatch = useAppDispatch();

    const goToClubPrepaidBagBalance = (club: Club) => {
        dispatch(handleClubChange(club.id))
        nav(buildUrl(PLATFORM_CLUB_PREPAID_BAG_DASHBOARD))
    }

    if (allClubs.filter((c) => c.hasPrepaidBags).length === 0) {
        return <></>
    }

    return (
        <div>
            <Container>
                <div className={"prepaidBagsHeader"}>
                    <p className={"prepaidBagsMenu_heading"}>Prepaid Bags</p>
                    <span className={"prepaidBagsMenu_info"}>Select the club from the list below to view your prepaid bag balance for that club.</span>
                </div>
            </Container>

            <div className={"prepaidBagsMenu"}>
                <Container>
                    {allClubs.filter((c) => c.hasPrepaidBags).map((club) => {
                        return (<div className={"prepaidBagsMenu_clubRow"} onClick={() => goToClubPrepaidBagBalance(club)}>
                        <p>{club.name}</p>
                        <ArrowLeftIcon size={IconSize.md} style={{ rotate: '180deg' }}/>
                    </div>)})}
                </Container>
            </div>
        </div>
    )
}

export default PrepaidBagsMenu;